module.exports = __webpack_public_path__ + "media/sub3-7-3.f83e7179.mp4";